import _getConst from '../../common/const'

let CONST = _getConst()
export const getConst = (url) => {
	CONST = _getConst(url)
	return CONST
}

export default CONST
